<svelte:options tag="auping-questionnaire" />

<script lang="ts">
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import Spinner from "./components/shared/Spinner.svelte";
  import { mattressWidth as mattressWidthStore } from "./stores/mattressWidth";
  import { questionnaire } from "./stores/questionnaire";
  import { translations } from "./stores/translations";
  import { prices } from "./stores/prices";
  import { locale as localeStore } from "./stores/locale";

  import Questionnaire from "./components/Questionnaire.svelte";
  import { derived } from "svelte/store";
  import { ButtonType } from "./types/button-type";

  export let locale: string;
  export let mattresswidth: number | null = null;
  export let submitreset: boolean = false;

  /**
   * Checks if all required data to render the questionnaire is available.
   */
  const appInitialized = derived(
    [translations, prices, questionnaire],
    (stores) => {
      return stores.every((store) => !!store);
    }
  );

  $: {
    if (locale) {
      try {
        localeStore.init(locale);
        translations.init(locale);
        prices.init(locale);
      } catch (e) {
        console.error(e.message);
      }
    }
  }

  $: {
    mattressWidthStore.init(mattresswidth);
    questionnaire.init();
  }

  onMount(() => {
    if (!locale)
      console.error(
        "No locale set! Please provide a valid 'locale' attribute."
      );
  });
</script>

<svelte:head>
  <style>
    @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&family=Roboto+Slab:wght@700&display=swap");
  </style>
</svelte:head>

{#if $appInitialized}
  <Questionnaire {submitreset} />
{:else}
  <div transition:fade class="spinner">
    <Spinner />
  </div>
{/if}

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  .spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%);
  }
</style>
